(function() {
  'use strict';

  var DISCOUNT_CODE = 'BUNDLE20';
  var TRACKING_URL = 'https://script.google.com/macros/s/AKfycbybn9j-ZR4IL4QDEPGHYJIibTT_HIrySZznTDklTkrVgwPGJpgdV05eaS0-6SHBDF3W/exec';
  var qlHorlogeToegevoegd = false;

  var COLOR_SYNONYMS = {
    'blauw': 'blauw', 'blue': 'blauw', 'blau': 'blauw',
    'roze': 'roze', 'pink': 'roze', 'rosa': 'roze',
    'zwart': 'zwart', 'black': 'zwart', 'schwarz': 'zwart'
  };

  function generateSessionId() { return 'ql_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10); }
  function getSessionId() {
    var key = 'qlConfiguratorSessionId', id = null;
    try { id = sessionStorage.getItem(key); } catch(e) {}
    if (!id) { id = generateSessionId(); try { sessionStorage.setItem(key, id); } catch(e) {} }
    return id;
  }
  function sendTrackingData(payload) {
    if (!TRACKING_URL) return;
    var img = new Image(), params = [];
    for (var k in payload) { if (payload.hasOwnProperty(k)) params.push(encodeURIComponent(k) + '=' + encodeURIComponent(payload[k])); }
    img.src = TRACKING_URL + '?' + params.join('&');
  }
  function getExploreVariantId(colorHint, exploreInfo) {
    if (!exploreInfo) return null;
    var fallback = exploreInfo['blauw'] ? exploreInfo['blauw'].id : null;
    if (!colorHint) return fallback;
    var c = colorHint.toLowerCase().trim();
    var canonical = COLOR_SYNONYMS[c];
    if (!canonical) {
      var keys = Object.keys(COLOR_SYNONYMS);
      for (var i = 0; i < keys.length; i++) { if (c.indexOf(keys[i]) !== -1 || keys[i].indexOf(c) !== -1) { canonical = COLOR_SYNONYMS[keys[i]]; break; } }
    }
    if (canonical && exploreInfo[canonical]) return exploreInfo[canonical].id;
    return fallback;
  }
  function applyDiscount() { return fetch('/discount/' + DISCOUNT_CODE, { method: 'GET', credentials: 'same-origin' }).catch(function() {}); }
  function setCartAttributes(attrs) { return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function() {}); }
  function clearCart() { return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }).catch(function() {}); }

  function initSamenstellenBtn(sessionId) {
    var btn = document.getElementById('qlSamenstellenBtn'), cfg = document.getElementById('qlConfigurator');
    if (!btn || !cfg) return;
    var labelOpen = btn.dataset.labelOpen || 'Samenstellen', labelClose = btn.dataset.labelClose || 'Sluiten';
    btn.addEventListener('click', function() {
      if (!cfg.hasAttribute('hidden')) { cfg.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); btn.textContent = labelOpen; return; }
      var variantId = cfg.dataset.variantId;
      if (!variantId) { var inp = document.querySelector('input[name="id"], select[name="id"]'); if (inp) variantId = inp.value; }
      if (!variantId) return;
      cfg.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); btn.textContent = labelClose;
      if (typeof clarity === 'function') { clarity('set', 'rollouts_variant', 'control'); }
      if (typeof gtag === 'function') { gtag('event', 'samenstel_knop_open', { rollouts_variant: 'control' }); }
      setTimeout(function() { cfg.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
      if (!qlHorlogeToegevoegd) {
        qlHorlogeToegevoegd = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }) })
          .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
          .then(function(r) { if (!r.ok) { qlHorlogeToegevoegd = false; return; } return setCartAttributes({ 'qlokkie_session_id': sessionId }); })
          .catch(function() { qlHorlogeToegevoegd = false; });
      }
    });
  }

  function initConfigurator() {
    var root = document.querySelector('.ql-configurator');
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    var sessionId = getSessionId();
    var isSlimPro = root.dataset.slimPro === 'true';

    var exploreInfo = {};
    try { exploreInfo = JSON.parse(root.dataset.exploreInfo || '{}'); } catch(e) { exploreInfo = {}; }
    var exploreInfoByVariant = {};
    ['blauw', 'roze', 'zwart'].forEach(function(k) { if (exploreInfo[k] && exploreInfo[k].id != null) exploreInfoByVariant[String(exploreInfo[k].id)] = exploreInfo[k]; });

    var t = {
      shippingFree: root.dataset.tShippingFree || 'Gratis verzending!',
      shippingRemaining: root.dataset.tShippingRemaining || 'Nog AMOUNT voor gratis verzending',
      notAdded: root.dataset.tNotAdded || 'niet toegevoegd',
      clickToAdd: root.dataset.tClickToAdd || 'Klik om toe te voegen',
      labelSp: root.dataset.tLabelSp || 'Screenprotector',
      labelBandje: root.dataset.tLabelBandje || 'Bandje',
      labelCharger: root.dataset.tLabelCharger || 'Adapter',
      checkout: root.dataset.tCheckout || 'Afrekenen',
      youSave: root.dataset.tYouSave || 'Je bespaart',
      uspSim: root.dataset.tUspSim || 'Gratis simkaart inbegrepen',
      backToOverview: '\u2190 Terug naar overzicht'
    };

    var productColor = (root.dataset.productColor || '').toLowerCase();
    var productTitle = root.dataset.productTitle || '';
    var locale = document.documentElement.lang || '';
    var KEY_TO_STEP = {}, steps = Array.from(root.querySelectorAll('.ql-step')), totalSteps = steps.length;
    var currentStep = 0, fromOverview = false, overviewIdx = -1;
    var selections = {}, refreshOverview = null, exploreMode = false, exploreVariantId = null;
    var basePrice = parseInt(root.dataset.basePrice || '0', 10), freeShippingThreshold = parseInt(root.dataset.freeShipping || '11000', 10), DISC = 0.8;

    // Zoek de overview stap index
    steps.forEach(function(s, i) { if (s.dataset.stepType === 'overview') overviewIdx = i; });

    function formatMoney(cents) { return '\u20ac\u00a0' + (cents / 100).toFixed(2).replace('.', ','); }
    function getEffectiveBasePrice() { if (exploreMode && exploreVariantId && exploreInfoByVariant[exploreVariantId]) return exploreInfoByVariant[exploreVariantId].price; return basePrice; }
    function totalCents() { var total = getEffectiveBasePrice(); Object.values(selections).forEach(function(s) { if (s) total += s.price; }); return total; }
    function totalOrigCents() { var total = getEffectiveBasePrice(); Object.values(selections).forEach(function(s) { if (s) total += (s.origPrice != null ? s.origPrice : s.price); }); return total; }
    function updateTotal() { var val = formatMoney(totalCents()); root.querySelectorAll('.ql-total-price').forEach(function(el) { el.textContent = val; }); }
    function updatePriceSummary() {
      var origEl = document.getElementById('qlOrigTotal'), newEl = document.getElementById('qlNewTotal'), savingsRow = document.getElementById('qlSavingsRow'), savingsAmountEl = document.getElementById('qlSavingsAmount');
      if (!origEl || !newEl) return;
      var newTotal = totalCents(), origTotal = totalOrigCents(), savings = origTotal - newTotal;
      newEl.textContent = formatMoney(newTotal);
      if (savings > 0) { origEl.textContent = formatMoney(origTotal); origEl.style.display = ''; if (savingsRow) savingsRow.style.display = ''; if (savingsAmountEl) savingsAmountEl.textContent = formatMoney(savings); }
      else { origEl.style.display = 'none'; if (savingsRow) savingsRow.style.display = 'none'; }
    }
    function updateShippingBar() {
      var bar = document.getElementById('qlShippingBar'), txt = document.getElementById('qlShippingText');
      if (!bar || !txt) return;
      var total = totalCents();
      if (total >= freeShippingThreshold) { bar.className = 'ql-shipping-bar is-free'; txt.textContent = t.shippingFree; }
      else { bar.className = 'ql-shipping-bar is-paid'; txt.textContent = t.shippingRemaining.replace('AMOUNT', formatMoney(freeShippingThreshold - total)); }
    }

    function updateStepFooter(step) {
      // Wissel de prev-knop label als we vanuit overzicht komen
      var prevBtn = step.querySelector('.ql-btn-prev');
      if (!prevBtn) return;
      if (fromOverview) {
        prevBtn.textContent = t.backToOverview;
        prevBtn.dataset.backToOverview = '1';
      } else {
        prevBtn.textContent = '\u2190 ' + (root.dataset.tPrev || 'Vorige');
        prevBtn.dataset.backToOverview = '';
      }
      // Verberg ook de skip-knop als we vanuit overzicht komen (bij bandje)
      var skipBtn = step.querySelector('.ql-skip');
      if (skipBtn) skipBtn.style.display = fromOverview ? 'none' : '';
    }

    function showStep(idx) {
      steps.forEach(function(s, i) { s.classList.toggle('ql-step--active', i === idx); });
      updateDots(idx);
      updateTotal();
      if (steps[idx]) updateStepFooter(steps[idx]);
      if (steps[idx] && steps[idx].dataset.stepType === 'overview' && refreshOverview) refreshOverview();
    }
    function updateDots(idx) { root.querySelectorAll('.ql-dot').forEach(function(d, i) { d.classList.toggle('ql-dot--active', i === idx); d.classList.toggle('ql-dot--done', i < idx); }); }
    function next() {
      if (fromOverview && overviewIdx >= 0) { fromOverview = false; goToStep(overviewIdx); return; }
      if (currentStep < totalSteps - 1) { currentStep++; showStep(currentStep); }
    }
    function prev() {
      if (fromOverview && overviewIdx >= 0) { fromOverview = false; goToStep(overviewIdx); return; }
      if (currentStep > 0) { currentStep--; showStep(currentStep); }
    }
    function goToStep(idx, opts) {
      fromOverview = !!(opts && opts.fromOverview);
      if (idx >= 0 && idx < totalSteps) { currentStep = idx; showStep(idx); }
    }

    function initChoiceStep(step, stepIdx) {
      var key = step.dataset.key; KEY_TO_STEP[key] = stepIdx;
      step.querySelectorAll('.ql-choice-row').forEach(function(row) {
        if (row.dataset.oos) return;
        row.addEventListener('click', function() {
          var value = row.dataset.value;
          if (key === 'screenprotector' && value === 'no') {
            var overlay = root.querySelector('.ql-sp-overlay');
            if (overlay) {
              overlay.classList.add('ql-sp-overlay--visible');
              overlay.querySelector('.ql-sp-confirm').onclick = function() {
                overlay.classList.remove('ql-sp-overlay--visible');
                selectChoice(step, row, key, value);
                next();
              };
              overlay.querySelector('.ql-sp-cancel').onclick = function() { overlay.classList.remove('ql-sp-overlay--visible'); };
              return;
            }
          }
          if (key === 'whatsapp_upsell' && value === 'yes_explore') { handleExploreUpsell(row); return; }
          selectChoice(step, row, key, value);
          setTimeout(next, 180);
        });
      });
    }

    async function handleExploreUpsell(btn) {
      if (btn) { btn.style.opacity = '0.6'; btn.style.pointerEvents = 'none'; }
      var vid = getExploreVariantId(productColor, exploreInfo);
      if (!vid) { if (btn) { btn.style.opacity = ''; btn.style.pointerEvents = ''; } return; }
      if (selections['screenprotector'] && selections['screenprotector'].variantId && exploreInfo.screenprotector) { var spOrigPrice = parseInt(selections['screenprotector'].origPrice || exploreInfo.screenprotector.price, 10); selections['screenprotector'] = { variantId: exploreInfo.screenprotector.id, price: Math.round(spOrigPrice * DISC), origPrice: spOrigPrice, title: t.labelSp, value: 'yes', img: exploreInfo.screenprotector.img }; }
      var items = [{ id: parseInt(vid, 10), quantity: 1 }];
      Object.values(selections).forEach(function(s) { if (s && s.variantId) items.push({ id: parseInt(s.variantId, 10), quantity: 1 }); });
      try {
        await clearCart();
        var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Fout');
        exploreMode = true; exploreVariantId = vid;
        await setCartAttributes({ 'qlokkie_session_id': sessionId });
        if (overviewIdx >= 0) goToStep(overviewIdx);
        if (btn) { btn.style.opacity = ''; btn.style.pointerEvents = ''; }
      } catch(e) { if (btn) { btn.style.opacity = ''; btn.style.pointerEvents = ''; } }
    }

    function selectChoice(step, row, key, value) {
      step.querySelectorAll('.ql-choice-row').forEach(function(r) { r.classList.remove('ql-choice-row--selected'); });
      row.classList.add('ql-choice-row--selected');
      var origPrice = parseInt(row.dataset.origPrice || row.dataset.price || '0', 10);
      selections[key] = (value === 'no' || value === 'no_explore') ? null : { variantId: row.dataset.variantId || null, price: Math.round(origPrice * DISC), origPrice: origPrice, title: row.dataset.title || '', value: value, img: row.dataset.img || '' };
      updateTotal();
    }

    function initBandjeStep(step, stepIdx) {
      var key = step.dataset.key; KEY_TO_STEP[key] = stepIdx;
      var skipBtn = step.querySelector('.ql-skip');
      if (skipBtn) skipBtn.addEventListener('click', function() {
        selections[key] = null;
        step.querySelectorAll('.ql-swatch').forEach(function(s) { s.classList.remove('ql-swatch--selected'); });
        next();
      });
      step.querySelectorAll('.ql-swatch').forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          step.querySelectorAll('.ql-swatch').forEach(function(s) { s.classList.remove('ql-swatch--selected'); });
          swatch.classList.add('ql-swatch--selected');
          var origPrice = parseInt(swatch.dataset.origPrice || swatch.dataset.price || '0', 10);
          selections[key] = { variantId: swatch.dataset.variantId, price: Math.round(origPrice * DISC), origPrice: origPrice, title: swatch.dataset.title, value: swatch.dataset.color, img: swatch.dataset.img || '' };
          updateTotal();
          setTimeout(next, 180);
        });
      });
    }

    function initOpladerStep(step, stepIdx) {
      var key = step.dataset.key; KEY_TO_STEP[key] = stepIdx; KEY_TO_STEP['adapter'] = stepIdx;
      step.querySelectorAll('.ql-oplader-card').forEach(function(card) {
        if (card.dataset.oos) return;
        card.addEventListener('click', function() {
          step.querySelectorAll('.ql-oplader-card').forEach(function(c) { c.classList.remove('ql-oplader-card--selected'); });
          card.classList.add('ql-oplader-card--selected');
          var value = card.dataset.value;
          if (value === 'no') { selections[key] = null; selections['adapter'] = null; }
          else if (value === 'combi') { var oplOrig = parseInt(card.dataset.oplOrigPrice || '0', 10), adaOrig = parseInt(card.dataset.adaOrigPrice || '0', 10); selections[key] = { variantId: card.dataset.oplVariantId, price: Math.round(oplOrig * DISC), origPrice: oplOrig, title: 'Extra oplaadkabel', value: 'oplader', img: card.dataset.oplImg || '' }; selections['adapter'] = { variantId: card.dataset.adaVariantId, price: Math.round(adaOrig * DISC), origPrice: adaOrig, title: 'Adapter', value: 'adapter', img: card.dataset.adaImg || '' }; }
          else { var origPrice = parseInt(card.dataset.origPrice || '0', 10); selections[key] = { variantId: card.dataset.variantId, price: Math.round(origPrice * DISC), origPrice: origPrice, title: card.dataset.title || '', value: value, img: card.dataset.img || '' }; selections['adapter'] = null; }
          updateTotal();
          setTimeout(next, 180);
        });
      });
    }

    function initOverviewStep(step) {
      var editLink = document.getElementById('qlOverviewEditLink');
      if (editLink) editLink.addEventListener('click', function() { fromOverview = false; goToStep(0); });

      function refresh() {
        if (exploreMode && exploreVariantId && exploreInfoByVariant[exploreVariantId]) {
          var info = exploreInfoByVariant[exploreVariantId], nameEl = step.querySelector('.ql-overview-name'), priceEl = step.querySelector('.ql-overview-price'), imgWrap = step.querySelector('.ql-overview-img');
          if (nameEl) nameEl.textContent = info.title; if (priceEl) priceEl.textContent = formatMoney(info.price);
          if (imgWrap) imgWrap.innerHTML = '<img src="' + info.img + '" alt="' + escHtml(info.title) + '" width="120" height="120" style="width:100%;height:100%;object-fit:cover;display:block;">';
        }
        var accEl = document.getElementById('qlOverviewAccessories');
        if (!accEl) { updateTotal(); updatePriceSummary(); updateShippingBar(); return; }
        accEl.innerHTML = '';

        var accDefs;
        if (isSlimPro) {
          accDefs = [
            { key: 'oplader', label: t.labelCharger, stepKey: 'oplader' },
            { key: 'adapter', label: 'Adapter', stepKey: 'adapter' }
          ];
        } else {
          accDefs = [
            { key: 'screenprotector', label: t.labelSp, stepKey: 'screenprotector' },
            { key: 'bandje', label: t.labelBandje, stepKey: 'bandje' },
            { key: 'oplader', label: t.labelCharger, stepKey: 'oplader' },
            { key: 'adapter', label: 'Adapter', stepKey: 'adapter' }
          ];
        }

        accDefs.forEach(function(def) {
          var val = selections[def.key];
          if (def.key === 'adapter' && (!val || !val.variantId)) return;
          var div = document.createElement('div');
          var stepIdx = KEY_TO_STEP[def.stepKey];
          if (val && val.variantId) {
            div.className = 'ql-acc-row ql-acc-row--clickable';
            div.title = 'Wijzigen';
            var imgHtml = val.img ? '<div class="ql-acc-img"><img src="' + val.img + '" alt="' + escHtml(val.title) + '" loading="lazy"></div>' : '<div class="ql-acc-img"></div>';
            var priceHtml = val.origPrice && val.origPrice !== val.price ? '<span class="ql-acc-price"><span class="ql-acc-price-disc">' + formatMoney(val.price) + '</span> <span class="ql-acc-price-orig">' + formatMoney(val.origPrice) + '</span></span>' : '<span class="ql-acc-price">' + formatMoney(val.price) + '</span>';
            div.innerHTML = imgHtml + '<span class="ql-acc-name">' + escHtml(val.title) + '</span>' + priceHtml;
            if (stepIdx !== undefined) div.addEventListener('click', function() { goToStep(stepIdx, { fromOverview: true }); });
          } else {
            if (exploreMode) return;
            if (isSlimPro) return;
            div.className = 'ql-acc-row ql-acc-row--clickable';
            if (stepIdx !== undefined) div.addEventListener('click', function() { goToStep(stepIdx, { fromOverview: true }); });
            div.innerHTML = '<div class="ql-acc-img"><span class="ql-acc-img-plus">+</span></div><span class="ql-acc-name ql-acc-not-chosen">' + escHtml(def.label) + '</span><span class="ql-acc-add-hint">' + t.clickToAdd + ' &rarr;</span>';
          }
          accEl.appendChild(div);
        });
        updateTotal(); updatePriceSummary(); updateShippingBar();
      }

      var atcBtn = step.querySelector('.ql-atc');
      if (atcBtn) {
        atcBtn.addEventListener('click', async function() {
          atcBtn.disabled = true; atcBtn.textContent = '...';
          var finalProduct = exploreMode && exploreVariantId && exploreInfoByVariant[exploreVariantId] ? exploreInfoByVariant[exploreVariantId].title : productTitle;
          sendTrackingData({ action: 'log_event', session_id: sessionId, product_title: finalProduct, product_color: productColor, locale: locale, screenprotector: selections['screenprotector'] ? 'ja' : 'nee', bandje: selections['bandje'] ? (selections['bandje'].value || 'ja') : 'nee', oplader_adapter: selections['oplader'] ? (selections['adapter'] ? 'combi' : selections['oplader'].value) : 'nee', explore_upsell: exploreMode ? 'ja' : 'nee', total_price: (totalCents() / 100).toFixed(2) });
          try {
            if (exploreMode) { await setCartAttributes({ 'qlokkie_bundel': 'configurator-explore-upsell', 'qlokkie_session_id': sessionId }); await applyDiscount(); window.location.href = '/checkout'; }
            else {
              var items = []; Object.values(selections).forEach(function(s) { if (s && s.variantId) items.push({ id: parseInt(s.variantId, 10), quantity: 1 }); });
              await setCartAttributes({ 'qlokkie_bundel': 'configurator', 'qlokkie_session_id': sessionId });
              if (items.length > 0) { var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }); var data = await res.json(); if (!res.ok) throw new Error(data.description || data.message || 'Fout'); }
              await applyDiscount(); window.location.href = '/checkout';
            }
          } catch(e) { atcBtn.disabled = false; atcBtn.textContent = t.checkout; }
        });
      }
      return refresh;
    }

    function escHtml(s) { return String(s).replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

    // Prev-knoppen: check of we vanuit overzicht komen
    root.querySelectorAll('.ql-btn-prev').forEach(function(btn) {
      btn.addEventListener('click', prev);
    });

    steps.forEach(function(step, idx) {
      var type = step.dataset.stepType;
      if (type === 'choice') initChoiceStep(step, idx);
      if (type === 'bandje') initBandjeStep(step, idx);
      if (type === 'oplader') initOpladerStep(step, idx);
      if (type === 'overview') refreshOverview = initOverviewStep(step);
    });

    showStep(0);
    return sessionId;
  }

  function init() { var sessionId = initConfigurator(); initSamenstellenBtn(sessionId); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
